var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zoom-drag-block"},[_c('iframe',{attrs:{"id":"turn-book","frameborder":"0","src":_vm.pdf}}),_c('el-image',{ref:"image__preview",staticClass:"no-show",staticStyle:{"width":"10px","height":"10px"},attrs:{"src":_vm.pdfImg[0],"preview-src-list":_vm.pdfImg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }